import "../index.css";
import { useState } from "react";
import Button from "../components/button/button";
import PolicyContainer from "../components/policy/policyContainer";
import axios from "axios";
import { baseURL } from "../baseURL";

const PopUpFormCollaborate = ({ onClose, onSuccess, onError }) => {
  const [formData, setFormData] = useState({});
  const [successMessage, setSuccessMessage] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmitCollabForm = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/api/submit-collab-form`,
        formData,
        {
          withCredentials: "true", // This matches the backend CORS policy
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.status === 200) {
        onSuccess("collab");
        onClose();
      }
    } catch (error) {
      console.error("Error submitting form:", error.response || error.message);
      onError(error);
    }
  };

  return (
    <>
      <div className="pop-up-form">
        <div className="form-header">
          <h4>Collaborate With Us</h4>
          <div className="close-btn-x" onClick={onClose}>
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <form id="collabForm" onSubmit={handleSubmitCollabForm}>
          <p>
            Providing your contact information enables us to share best
            practices, communicate updates, and network with our global wildfire
            prevention community.
          </p>
          <div className="form-group">
            <label for="firstName">*First Name</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              onChange={handleChange}
              value={formData.firstName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label for="lastName">*Last Name</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              onChange={handleChange}
              value={formData.lastName || ""}
              required
            />
          </div>
          <div className="form-group">
            <label for="email">*Email</label>
            <input
              type="email"
              id="email"
              name="email"
              onChange={handleChange}
              value={formData.email || ""}
              required
            />
          </div>
          <div className="form-group">
            <label for="organization">Organization</label>
            <input
              type="text"
              id="organization"
              name="organization"
              onChange={handleChange}
              value={formData.organization || ""}
            />
          </div>
          <div className="form-group">
            <label for="role">Role</label>
            <input type="text" id="role" name="role" onChange={handleChange} />
          </div>
          <div className="form-group">
            <label for="zipCode">*Zip/Postal Code </label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              onChange={handleChange}
              value={formData.zipCode || ""}
              required
              minLength={4}
            />
          </div>
          <p>Interested in collaborating:</p>
          <div className="form-check">
            <input
              type="checkbox"
              id="pilotScorecard"
              onChange={handleChange}
              name="pilotScorecard"
              value={formData.pilotScorecard || ""}
            />
            <label for="pilotScorecard">Piloting scorecard</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="generalCollaboration"
              name="generalCollaboration"
              onChange={handleChange}
              value={formData.generalCollaboration || ""}
            />
            <label for="generalCollaboration">General collaboration</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="toShare"
              name="toShare"
              onChange={handleChange}
              value={formData.toShare || ""}
            />
            <label for="toShare">Sharing data & learnings</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="subscribe"
              name="subscribe"
              onChange={handleChange}
              value={formData.subscribe || ""}
            />
            <label for="subscribe">Subscribe to updates, events and news</label>
          </div>
          <div className="form-check">
            <input
              type="checkbox"
              id="other"
              name="other"
              onChange={handleChange}
              value={formData.other || ""}
            />
            <label for="other">Other</label>
          </div>
          <br />
          <div className="form-group">
            <label for="message">Message</label>
            <textarea
              id="message"
              name="message"
              cols="50"
              onChange={handleChange}
              value={formData.message || ""}
            ></textarea>
          </div>

          <Button
            text="Collaborate"
            color="var(--green)"
            className="pop-up-btn"
          ></Button>
        </form>
        <div className="policy">
          <PolicyContainer text="Collaborate" />
        </div>
        <div className="form-footer">
          <div className="form-close-btn" onClick={onClose}>
            Close
          </div>
        </div>
      </div>
    </>
  );
};

export default PopUpFormCollaborate;
